<div *ngIf="globalService.showLoadingScreen" class="loadingScreen">
    <mat-spinner></mat-spinner>
  </div>

<router-outlet></router-outlet>
